import React from 'react';
import { connect } from 'react-redux';

import Template from './../../templates/Infoupd';
import { commonOperations } from './../../../reducks/common';
import { infoupdOperations } from './../../../reducks/infoupd'; 

const mapStateToProps = state => ({
  currentTheme: state.common.theme,
});
const mapDispatchToProps = {
  //action: operation,
  doCheckResponse: commonOperations.checkResponseOperation,
  doOpenDialogOperation: commonOperations.openDialogOperation,
  openDialogOperation: commonOperations.openDialogOperation,
  doClearStore: commonOperations.storeInit,
  doSetShelterName: infoupdOperations.setShelterNameOperation,
  doSetRegisteredKojinInfoList: infoupdOperations.setRegisteredKojinInfoListOperation,
  doGetKojin: infoupdOperations.getKojin,
  doSetKojin: infoupdOperations.setKojin
};

class App extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "入退所情報更新";

    let param = window.location.search.substring(1).split('=');
    let place = decodeURIComponent(param[1]);
    if ( place === "" || place === 'undefined'){
      place = "避難所";
    }

    this.props.doSetShelterName(place);
  }

  componentWillMount() {
    this.props.doClearStore();
    localStorage.clear();
  }

  render() {
    return (
      <Template {...this.props} />
    );
  }
}

const ContainerApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
export default ContainerApp;
